import { Model } from 'pinia-orm'
import Child from './Child'

export default class ScreenTimeEvent extends Model {
  // entity is a required property for all models.
  static entity = 'ScreenTimeEvent'

  static fields() {
    return {
      id: this.uid(), // Use uuid for unique identifier
      timestamp: this.attr(null), // Nullable field for timestamp
      impact: this.number(0),
      timeBefore: this.number(0),
      timeAfter: this.number(0),
      description: this.string(''),

      // Relationships
      childId: this.attr(null),
      child: this.belongsTo(Child, 'childId'),
    }
  }

  declare id: string
  declare timestamp: number | null
  declare impact: number
  declare timeBefore: number
  declare timeAfter: number
  declare description: string
  declare childId: string | null
  declare child: Child | null
}
